<script lang="ts" setup>
import type { PDataTableColumnName } from '../types'
import type { ResizeSide } from '../composables/columnResize'

type Props = {
  side: ResizeSide
  target: PDataTableColumnName | null
}

defineProps<Props>()

const emits = defineEmits<{
  (e: 'start', event: PointerEvent, target: PDataTableColumnName): void
}>()

const onPointerDown = (event: PointerEvent, target: PDataTableColumnName): void => {
  emits('start', event, target)
}
</script>

<template>
  <span
    v-if="target"
    :class="['ds-data-table-column-resizer', `ds-data-table-column-resizer--${side}`]"
    aria-hidden="true"
    @pointerdown="onPointerDown($event, target)"
    @click.stop
    @dblclick.stop
  />
</template>
